<template>
  <div>
    <div class="nps-total" v-text="total"></div>
    <p class="has-text-centered">RECOMMENDED&nbsp;TO&nbsp;A&nbsp;FRIEND</p>
  </div>
</template>
<script>
  export default {
    name: 'NpsCirle',
    props: {
      total: {
        type: Number,
        default: 0
      }
    }
  }
</script>
<style scoped>
  .nps-total {
    display: block;
    width: 68px;
    height: 68px;
    border: 5px solid #2FABE1;
    border-radius: 50%;
    font-size: 1.2rem;
    text-align: center;
    line-height: 60px;
    font-weight: bold;
    color: #4a4a4a;
    margin-left: auto;
    margin-right: auto;
  }

  p {
    color: #58595B;
    font-size: 0.7rem;
    margin-top: 10px;
  }
</style>


// WEBPACK FOOTER //
// src/components/NpsCircle.vue